
export default {
    install() {
        const element = document.documentElement;
        const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
        const recalc = function () {
            let clientWidth = element.clientWidth;
            // console.log(clientWidth, 'clientWidth');
            const isMd = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            let baseWidth = 1920
            let baseSize = 100
            if (isMd) {
                baseWidth = 375
                baseSize = 50
            } else {
                if (clientWidth < 1200) {
                    clientWidth = 1200
                }
            }
            element.style.fontSize = `${baseSize * (clientWidth / baseWidth)}px`
        };
        recalc();
        if (!document.addEventListener) return;
        window.addEventListener(resizeEvt, recalc, false)
    }
}